export default __webpack_public_path__ + "static/media/steemit.4d6d95e7.svg";